import React from "react";
import { Controller } from "react-hook-form";
import {
  TextField,
  InputAdornment,
  IconButton,
  Typography,
  Box,
  Chip,
  Stack,
  alpha,
} from "@mui/material";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import CloseIcon from "@mui/icons-material/Close";
import { useSnackbar } from "../common/Snackbar";
function FormFileInputField(props) {
  const {
    control,
    required,
    fieldname,
    placeholder = "Select files",
    label,
    acceptedExtensions = [], // Array of accepted file extensions
    rules = null,
    maxFileSize = 0, // Maximum file size in bytes (default: no limit)
    ...restProps
  } = props;
  // Reference to the hidden file input
  const fileInputRef = React.useRef();

  const [SnackbarComponent, showSnackbar] = useSnackbar();
  const handleFieldClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click(); // Simulate a click on the file input
    }
  };
  const isFileAccepted = (file) => {
    // Check if the file has an accepted extension
    if (acceptedExtensions?.length === 0) return true; // Allow all if no restrictions
    const fileExtension = file?.name?.split(".")?.pop()?.toLowerCase();
    const isValidExtension =
      acceptedExtensions.length === 0 ||
      acceptedExtensions.includes(fileExtension);
    const isValidSize = maxFileSize === 0 || file.size <= maxFileSize;
    if (!isValidExtension) {
      showSnackbar(`Please upload only image and PDF files.`, "warning");
    } else if (!isValidSize) {
      showSnackbar(
        `File is too big, max size ${maxFileSize / 1024 / 1024} MB.`,
        "warning"
      );
    }
    return isValidExtension && isValidSize;
    // return acceptedExtensions?.includes(fileExtension);
  };
  return (
    <Controller
      name={fieldname}
      control={control}
      defaultValue={[]}
      rules={
        required ? { required: "Files are required!", ...rules } : rules || {}
      }
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Box>
          <Typography variant="body1" textAlign={"left"}>
            {label} {required && <span style={{ color: "red" }}>*</span>}
          </Typography>
          <TextField
            placeholder={placeholder}
            value={value?.length > 0 ? `${value?.length} file(s) selected` : ""}
            onChange={onChange}
            onClick={handleFieldClick} // Open file dialog on text field click
            size="small"
            variant="outlined"
            fullWidth
            readOnly
            helperText={error ? error.message : null}
            error={!!error}
            InputProps={{
              readOnly: true,
              sx: {
                paddingRight: 0, // Remove right padding
              },
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    // component="label"
                    sx={{
                      backgroundColor: (theme) =>
                        alpha(theme.palette.primary.main, 0.3),
                      borderRadius: 1,
                      "&:hover": {
                        backgroundColor: (theme) =>
                          alpha(theme.palette.primary.main, 0.5),
                      },
                    }}
                  >
                    <FolderOpenIcon />
                    <input
                      ref={fileInputRef} // Assign ref to the file input
                      type="file"
                      hidden
                      accept={acceptedExtensions
                        .map((ext) => `.${ext}`)
                        .join(",")} // Convert extensions to accept format
                      multiple
                      onChange={(e) => {
                        // onChange(Array.from(e.target.files)); // Directly update value with selected files
                        // e.target.value = null; // Reset the file input value
                        const selectedFiles = Array.from(e.target.files);
                        const filteredFiles =
                          selectedFiles.filter(isFileAccepted);
                        // console.log(filteredFiles);
                        // if (filteredFiles.length < selectedFiles.length) {
                        //   showSnackbar(
                        //     "Some files were not accepted. Please upload only image and PDF files.",
                        //     "warning"
                        //   );
                        // }
                        onChange(filteredFiles);
                        e.target.value = null;
                      }}
                    />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            {...restProps}
          />
          {value?.length > 0 && (
            <Stack direction="row" flexWrap="wrap" mt={1}>
              {value?.map((file, index) => (
                <Chip
                  key={index}
                  label={file?.name}
                  onDelete={() => {
                    // Filter out the deleted file from the value and pass back to onChange
                    const updatedFiles = value?.filter(
                      (fileItem) => fileItem?.name !== file.name
                    );
                    onChange(updatedFiles);
                  }}
                  deleteIcon={<CloseIcon color="primary" />}
                  variant="outlined"
                  sx={{
                    backgroundColor: (theme) =>
                      theme.palette.background.default, // Light background for each chip
                    // borderColor: (theme) => theme.palette.primary.main, // Light background for each chip
                    marginBottom: "6px !important", // Space between chips
                    marginRight: "6px !important", // Space between chips
                  }}
                />
              ))}
            </Stack>
          )}
          <SnackbarComponent />
        </Box>
      )}
    />
  );
}

export default FormFileInputField;
